module.exports = __webpack_public_path__ + "img/error.0e62f45.svg";